import { getFullPath, routes } from "../routes";
import { Navigate, useParams } from "react-router";
import { ScopeOfWorkForm } from "./form";
import { useScopeOfWork } from "./hooks";

export function EditScope() {
  const { id } = useParams();
  const { data, isLoading, isError } = useScopeOfWork(id);

  if (isLoading) {
    return <p>Loading...</p>;
  } else if (isError) {
    return <p>An unknown error occurred.</p>;
  } else if (data) {
    return <ScopeOfWorkForm data={data} />;
  } else {
    return <Navigate to={getFullPath(routes.scopeOfWork.create)} />;
  }
}
